import { NgModule } from '@angular/core';
import { OwnedContactsAppliedFilterTextComponent } from './owned-contacts-applied-filter-text.component';
import { CommonModule } from '@angular/common';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    declarations: [OwnedContactsAppliedFilterTextComponent],
    exports: [
        OwnedContactsAppliedFilterTextComponent
    ],
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule
    ]
})
export class OwnedContactsAppliedFilterTextModule {

}
